export default "__VITE_ASSET__Ca3IKPkm__"